// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-ee48347a] .el-dialog__body {\n  padding: 10px 10px;\n  height: 500px;\n  overflow: auto;\n}\n.el-form-item--mini.el-form-item[data-v-ee48347a] {\n  margin-bottom: 10px;\n}\n.richtext[data-v-ee48347a] {\n  height: 410px;\n}\n.richtext > div[data-v-ee48347a] {\n  height: 100%;\n}", ""]);
// Exports
module.exports = exports;
